var map = {
	"./AGROCHEMICALS.webp": 3308,
	"./AUTO COMPONENTS.webp": 2784,
	"./Automobile.webp": 1275,
	"./BUILDING MATERIALS.webp": 7622,
	"./CHEMICALS.webp": 714,
	"./DIAGNOSTICS.webp": 5680,
	"./EDUCATION.webp": 4902,
	"./ELECTRICAL & ELECTRONICS.webp": 9360,
	"./FOOD.webp": 2133,
	"./Food-Processing-Unit.webp": 7871,
	"./HEALTHCARE.webp": 8243,
	"./INFRASTRUCTURE.webp": 8013,
	"./INK.webp": 685,
	"./LOGISTICS.webp": 770,
	"./MANUFACTURING.webp": 8487,
	"./METAL, MINERALS & MINING.webp": 4773,
	"./OIL & GAS.webp": 1845,
	"./PACKAGING.webp": 6599,
	"./PHARMA, LIFESCIENCES & DEVICES.webp": 9858,
	"./RENEWABLE ENERGY.webp": 2363,
	"./SOFTWARE.webp": 743,
	"./SUPERMARKET-TROLLEY-FMCG.webp": 1531,
	"./TECHNOLOGY.webp": 859,
	"./TEXTILE.webp": 9326,
	"./agrochemical.webp": 8565,
	"./engineering-plastics.webp": 1936,
	"./global_trade_trends_2021__1_.webp": 1933,
	"./industrial.webp": 6073,
	"./instrumentation.webp": 960,
	"./investment.webp": 9319,
	"./lifescience.webp": 9049,
	"./metal-casting.webp": 4819,
	"./metal_mining.webp": 5370,
	"./power.webp": 1653,
	"./railway-oem.webp": 8783,
	"./shipment.webp": 6964,
	"./shipping-infrastructure.webp": 3491,
	"./yarn.webp": 3412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5898;